"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLinkAliases = void 0;
var utils_1 = require("./utils");
var getLinkAliases = function (globals, brand) {
    var colors = globals.colors;
    var _a = (0, utils_1.getLinkBrandColors)(colors, brand), _b = _a.primary, primaryActive = _b.active, primaryVisited = _b.visited, primaryDisabled = _b.disabled, _c = _a.secondary, secondaryActive = _c.active, secondaryVisited = _c.visited, secondaryDisabled = _c.disabled, _d = _a.negative, negativeActive = _d.active, negativeVisited = _d.visited, negativeDisabled = _d.disabled;
    return {
        stateColors: {
            // branded
            primary: {
                default: colors.primary.brand,
                hover: colors.secondary.brand,
                focus: colors.primary.brand,
                active: primaryActive,
                visited: primaryVisited,
                disabled: primaryDisabled,
            },
            // black
            secondary: {
                default: colors.primary.black,
                hover: colors.primary.black,
                focus: colors.primary.black,
                active: secondaryActive,
                visited: secondaryVisited,
                disabled: secondaryDisabled,
            },
            // white
            negative: {
                default: colors.primary.white,
                hover: colors.primary.white,
                focus: colors.primary.white,
                active: negativeActive,
                visited: negativeVisited,
                disabled: negativeDisabled,
            },
        },
        fontFamily: globals.fonts.secondary.regular,
    };
};
exports.getLinkAliases = getLinkAliases;
